import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
  OnDestroy,
} from "@angular/core";
import { Table, TableModule } from "primeng/table";
import * as FileSaver from "file-saver";
import { ActivatedRoute } from "@angular/router";
import { FreightChargesInvoicePreviewDetailValue } from "../../../core/models/invoice-preview/freightChargesInvoicePreviewDetailValue";
import { InvoicePreviewSummaryService } from "../../../core/services/invoice-preview-summary.service";
import { LoaderService } from "../../../core/services/loader.service";
import { CommonModule } from "@angular/common";
import { SpinnerComponent } from "../../../shared/components/spinner/spinner.component";

@Component({
  selector: "jni-invoice-preview-freight-charges",
  templateUrl: "./freight-charges.component.html",
  styleUrls: ["./freight-charges.component.scss"],
  imports: [TableModule, CommonModule, SpinnerComponent],
})
export class InvoicePreviewFreightChargesComponent
  implements OnInit, OnDestroy
{
  @Input() saleOrderId = "";
  @Output() scrollHiddenStatus = new EventEmitter();

  freightChargesInvoicePreviewDetailValue: FreightChargesInvoicePreviewDetailValue[] =
    [];

  @ViewChild("dt") table!: Table;

  constructor(
    private _loaderService: LoaderService,
    public _activatedRoute: ActivatedRoute,
    private _invoicePreviewSummaryService: InvoicePreviewSummaryService
  ) {}

  ngOnInit(): void {
    this.getFreightCharges();
  }

  clearTable(table: Table) {
    table.clear();
  }

  exportExcelFile() {
    this.exportExcelForFilterData(this.freightChargesInvoicePreviewDetailValue);
  }

  exportExcelForFilterData(
    filterclientlist: FreightChargesInvoicePreviewDetailValue[]
  ) {
    const object = filterclientlist.map(datum => {
      return {
        ["Category"]: datum.ChargeCategory,
        ["Keep"]: datum.Keep,
        ["Amount"]: datum.ChargeValue,
        ["Currency"]: datum.currencyCode,
        ["Reference"]: datum.RsmReferenceCategory,
        ["Project Id"]: datum.ReferenceProjId,
        ["Number"]: datum.rsmReferenceId,
        ["Freight Bill #"]: datum.FreightBillingNum,
        ["Tracking"]: datum.TrackingNumber,
        ["Created By"]: datum.CreatedBy1,
        ["Created Date and Time"]: datum.CreatedDateTime1,
        ["Modified By"]: datum.modifiedBy1,
        ["Modified Date and Time"]: datum.ModifiedDateTime1,
      };
    });

    import("xlsx").then(xlsx => {
      const worksheet = xlsx.utils.json_to_sheet(object);
      const workbook = { Sheets: { data: worksheet }, SheetNames: ["data"] };
      const excelBuffer: ArrayBuffer = xlsx.write(workbook, {
        bookType: "xlsx",
        type: "array",
      });
      this.saveAsExcelFile(excelBuffer, "FreightChargeReport");
    });
  }

  saveAsExcelFile(buffer: ArrayBuffer, fileName: string): void {
    const EXCEL_TYPE =
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
    const EXCEL_EXTENSION = ".xlsx";
    const data: Blob = new Blob([buffer], {
      type: EXCEL_TYPE,
    });
    FileSaver.saveAs(
      data,
      fileName + "_export_" + new Date().getTime() + EXCEL_EXTENSION
    );
  }

  ngOnDestroy(): void {
    this.scrollHiddenStatus.emit();
  }

  getFreightCharges() {
    this._loaderService.setLoaderState(true);
    if (this.saleOrderId) {
      const oDataFilter = `?$filter=SalesId eq '${this.saleOrderId}'`;
      this._invoicePreviewSummaryService
        .getFreightChargesInvoicePreview(oDataFilter)
        .subscribe({
          next: res => {
            this.freightChargesInvoicePreviewDetailValue = res.data;
            this._loaderService.setLoaderState(false);
          },
          error: () => {
            this._loaderService.setLoaderState(false);
          },
        });
    }
  }
}
